import {ShapeSchemeType, SimpleShapeSchemeType} from "@consts/types";

const isSimpleShapeSchemeType = (type: ShapeSchemeType): type is SimpleShapeSchemeType => {
  return [ShapeSchemeType.ellipse, ShapeSchemeType.rectangle].includes(type);
}

export default isSimpleShapeSchemeType;